import React, {forwardRef} from 'react';
import css from './SectionTitle.module.scss';

const SectionTitle = forwardRef(({
  children,
  className,
  color,
  icon,
  ...props
}, ref) => {
  return (
    <h6
      ref={ref}
      className={`${css.sectionTitle} ${className || ''}`}
      style={{color: color}}
      {...props}
    >
      {icon && <span className={css.icon}>{icon}</span>}
      {children}
    </h6>
  );
});

SectionTitle.displayName = 'SectionTitle';

export default SectionTitle;
